import { base64Decode, base64Encode, isBase64 } from '../utils/base64';
import { ActivitySource } from './ActivitySource';
import { Book } from './Book';
import { Company } from './Company';
import { CourseSection } from './CourseSection';
import { Edition } from './Edition';
import { Enrollment } from './Enrollment';
import { Item } from './Item';
import { Person } from './Person';
import { Product } from './Product';
import { Term } from './Term';

export interface Citation extends Item {
  personId: number;
  person?: Person;

  productId?: number;
  product?: Product;

  enrollmentId?: number;
  enrollment?: Enrollment;

  publisherId: number;
  publisher: Company;

  bookId: number;
  book?: Book;

  editionId: number;
  edition?: Edition;

  schoolId?: number;
  school: Company;

  termId?: number;
  term?: Term;

  courseSectionId?: number;
  courseSection?: CourseSection;

  source: ActivitySource;
  text?: string;
  bibliography?: string;

  chapterId?: number;
  pageId?: number;
  document?: string;

  anchorId?: string;
  anchorOffset?: number;

  focusId?: string;
  focusOffset?: number;

  anchorTextIndex?: number;
  focusTextIndex?: number;

  cite: string;
}

export const translateCitationForTransport = (attributes: any): any => {
  const response = { ...attributes };

  if (attributes.text) {
    response.text = !isBase64(attributes.text) ? base64Encode(attributes.text) : attributes.text;
  }

  if (attributes.bibliography) {
    response.bibliography = !isBase64(attributes.bibliography)
      ? base64Encode(attributes.bibliography)
      : attributes.bibliography;
  }

  if (attributes.cite) {
    response.cite = !isBase64(attributes.cite) ? base64Encode(attributes.cite) : attributes.cite;
  }

  return response;
};

export const translateCitationFromTransport = (attributes: any): any => {
  const response = { ...attributes };

  if (attributes.text) {
    response.text = isBase64(attributes.text) ? base64Decode(attributes.text) : attributes.text;
  }

  if (attributes.bibliography) {
    response.bibliography = isBase64(attributes.bibliography)
      ? base64Decode(attributes.bibliography)
      : attributes.bibliography;
  }

  if (attributes.cite) {
    response.cite = isBase64(attributes.cite) ? base64Decode(attributes.cite) : attributes.cite;
  }

  return response;
};
